import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router";
import Login from "../../pages/login/Login";
import { GlobalContext } from "../../context/Context";
import OrganizationLayout from "../../pages/organization";
import OrganizationEmployeeDirectory from "../../pages/organization/emplyee-directory";
import TeamProfileLayout from "../../pages/organization/emplyee-directory/profile/layout";
import Brand from "../../pages/brands/brand";
import Logs from "../../pages/logs/logs";
import LogsLayout from "../../pages/logs";
import ProjectDetailLayout from "../../pages/projectDetails";
import ProjectDetailMain from "../../pages/projectDetails/details";
import ContactDetailLayout from "../../pages/contactDetails";
import ContactDetailMain from "../../pages/contactDetails/details";
import SettingsLayout from "../../pages/settings";
import Setting from "../../pages/settings/setting";
import WalletsLayout from "../../pages/wallets";
import Wallet from "../../pages/wallets/wallet";
import UsersLayout from "../../pages/settings/setting/mainOperations/users";
import PackagesLayout from "../../pages/settings/setting/mainOperations/packages";
import MerchantsLayout from "../../pages/settings/setting/mainOperations/merchants";
import SettingsPackages from "../../pages/settings/setting/mainOperations/packages/package";
import SettingsUsers from "../../pages/settings/setting/mainOperations/users/user";
import SettingsMerchants from "../../pages/settings/setting/mainOperations/merchants/merchant";
import ProductsLayout from "../../pages/settings/setting/mainOperations/products";
import SettingsProducts from "../../pages/settings/setting/mainOperations/products/product";
import TeamsLayout from "../../pages/settings/setting/mainOperations/teams";
import SettingsTeams from "../../pages/settings/setting/mainOperations/teams/team";
import SettingMerchantsType from "../../pages/settings/setting/mainOperations/merchants/merchant-type";
import LostDealLayout from "../../pages/settings/setting/mainOperations/lost-deals";
import SettingsLostDeals from "../../pages/settings/setting/mainOperations/lost-deals/lost-deal";
import DashboardLayoput from "../../pages/dashboard";
import Dashboard from "../../pages/dashboard/dashboard";
import LeadsMainLayout from "../../pages/mainleads";
import OrganizationOverview from "../../pages/mainleads/Organization/overview";
import LeadsOrganizationLayout from "../../pages/mainleads/Organization";
import OrganizationList from "../../pages/mainleads/Organization/Organization-list";
import LeadsLayout from "../../pages/mainleads/leads";
import Lead from "../../pages/mainleads/leads/lead";
import TeamsOverview from "../../pages/mainleads/team/overview";
import TeamLeads from "../../pages/mainleads/team/lead";
import LeadsTeamLayout from "../../pages/mainleads/team";
import LeadsOverview from "../../pages/mainleads/leads/overview";

import ProjectsLayout from "../../pages/projects";
import Project from "../../pages/projects/project";
import LeadDetailMain from "../../pages/mainleads/leadDetails/details";
import LeadDetailLayout from "../../pages/mainleads/leadDetails";
import AccountsMainLayout from "../../pages/mainAccounts";
import AccountsLayout from "../../pages/mainAccounts/accounts";
import Accounts from "../../pages/mainAccounts/accounts/account";
import AccountsOverview from "../../pages/mainAccounts/accounts/overview";
import AccountsTeamLayout from "../../pages/mainAccounts/team";
import AccountsTeamsOverview from "../../pages/mainAccounts/team/overview";
import TeamAccounts from "../../pages/mainAccounts/team/account";
import AccountsOrganizationLayout from "../../pages/mainAccounts/organization";
import AccountsOrganizationOverview from "../../pages/mainAccounts/organization/overview";
import OrganizationAccounts from "../../pages/mainAccounts/organization/account";
import AccountDetailLayout from "../../pages/mainAccounts/accountDetails";
import AccountDetailMain from "../../pages/mainAccounts/accountDetails/details";
import DealsMainLayout from "../../pages/mainDeals";
import DealsLayout from "../../pages/mainDeals/deals";
import Deals from "../../pages/mainDeals/deals/deal";
import DealsOverview from "../../pages/mainDeals/deals/overview";
import DealsTeamLayout from "../../pages/mainDeals/teams";
import DealsTeamOverview from "../../pages/mainDeals/teams/overview";
import TeamDeals from "../../pages/mainDeals/teams/deal";
import DealsOrganization from "../../pages/mainDeals/Organization/deal";
import DealsOrganizationOverview from "../../pages/mainDeals/Organization/overview";
import DealsOrganizationLayout from "../../pages/mainDeals/Organization";
import DealDetailLayout from "../../pages/mainDeals/dealDetails";
import DealDetailMain from "../../pages/mainDeals/dealDetails/details";
import ActivityMainLayout from "../../pages/mainActivities";
import ActivityLayout from "../../pages/mainActivities/activities";
import Activity from "../../pages/mainActivities/activities/activity";
import ActivityOverview from "../../pages/mainActivities/activities/overview";
import ActivityTeamLayout from "../../pages/mainActivities/team";
import ActivityTeamOverview from "../../pages/mainActivities/team/overview";
import ActivityTeam from "../../pages/mainActivities/team/activity";
import ActivityOrgLayout from "../../pages/mainActivities/organization";
import ActivityOrganizationOverview from "../../pages/mainActivities/organization/overview";
import OrganizationActivity from "../../pages/mainActivities/organization/activity";
import OperationsMainLayout from "../../pages/settings/setting/mainOperations";
import AgentsOverview from "../../pages/settings/setting/mainOperations/agents/overview";
import SettingAgents from "../../pages/settings/setting/mainOperations/agents/agent";
import AgentsLayout from "../../pages/settings/setting/mainOperations/agents";
import BrandsLayout from "../../pages/settings/setting/mainOperations/brands";
import SettingsBrands from "../../pages/settings/setting/mainOperations/brands/brand";
import MerchantsOverview from "../../pages/settings/setting/mainOperations/merchants/overview";
import BrandsOverview from "../../pages/settings/setting/mainOperations/brands/overview";
import PackagesOverview from "../../pages/settings/setting/mainOperations/packages/overview";
import ProductsOverview from "../../pages/settings/setting/mainOperations/products/overview";
import SettingsTeamsOverview from "../../pages/settings/setting/mainOperations/teams/overview";
import ClientsOverview from "../../pages/settings/setting/mainOperations/users/overview";
import TeamDashbaord from "../../pages/dashboard/Team";
import OrganizationDashboard from "../../pages/dashboard/Organization";
import TaskLayout from "../../pages/Tasks";
import TaskList from "../../pages/Tasks/task";
import TasksOverview from "../../pages/Tasks/overview";

import SaleMainLayout from "../../pages/mainSales";
import SaleLayout from "../../pages/mainSales/sales";
import SaleOverview from "../../pages/mainSales/sales/overview";
import Sale from "../../pages/mainSales/sales/sale";
import SaleTeamLayout from "../../pages/mainSales/team";
import SaleTeamOverview from "../../pages/mainSales/team/overview";
import SaleTeam from "../../pages/mainSales/team/sale";
import SaleOrgLayout from "../../pages/mainSales/organization";
import SaleOrganizationOverview from "../../pages/mainSales/organization/overview";
import OrganizationSale from "../../pages/mainSales/organization/sale";
import SaleAssigment from "../../pages/mainSales/sales/sale-assigments";
import TeamSaleAssigment from "../../pages/mainSales/team/sale-assigments";
import OrganizationSaleAssigment from "../../pages/mainSales/organization/sale-assigments";
import RefundLayout from "../../pages/refund-tracker";
import RefundMainLayout from "../../pages/refund-tracker";
import RefundOrgLayout from "../../pages/refund-tracker/Organization";
import OrgRefunds from "../../pages/refund-tracker/Organization/refund";
import OrgRefundsByDepartment from "../../pages/refund-tracker/Organization/refund-by-department";
import OrgRefundsBySalesAgent from "../../pages/refund-tracker/Organization/refund-by-sales-agent";
import OrgRefundsByAccountManager from "../../pages/refund-tracker/Organization/refund-by-account-manager";
import OrgRefundsByBrand from "../../pages/refund-tracker/Organization/refund-by-brand";
import OrgRefundsByMerchant from "../../pages/refund-tracker/Organization/refund-by-merchant";
import OrgRefundsByProduct from "../../pages/refund-tracker/Organization/refund-by-product";
import OrgRefundsBySource from "../../pages/refund-tracker/Organization/refund-by-source";
import OrgRefundsByTeamLead from "../../pages/refund-tracker/Organization/refund-by-team-lead";
import OrgRefundOverview from "../../pages/refund-tracker/Organization/overview";
import SystemSettingsLayout from "../../pages/system-settings";
import SystemSettings from "../../pages/system-settings/system-setting";
import LeadStatusLayout from "../../pages/lead-status-config";
import LeadStatusList from "../../pages/lead-status-config/status-list";
import ClientHealthLayout from "../../pages/client-Health";
import HealthFactorList from "../../pages/client-Health/health-factor";
import HealthScoreThresholds from "../../pages/client-Health/health-factor-thresholds";
import HealthPriorityFlags from "../../pages/client-Health/priority-flags";
import ClientRenewalsLayout from "../../pages/client-renewals";
import ClientRenewalsTracker from "../../pages/client-renewals/client-renewal";
import OrgRecycledLeadList from "../../pages/mainleads/Organization/recycled-leads";
import SettingsProductsCategory from "../../pages/settings/setting/mainOperations/products/category";
import SettingsProductsPackages from "../../pages/settings/setting/mainOperations/products/packages";
// import ClientHealthLayout from "../../pages/Client-Health";
// import HealthFactorList from "../../pages/Client-Health/health-factor";

const MyRoutes = () => {
  let { state } = useContext(GlobalContext);

  const privateRoutes = [
    {
      path: "/settings",
      element: <SettingsLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "setting",
          element: <Setting />,
        },
        // add other nested configs...
      ],
    },

    // Main Leads
    {
      path: "/leads",
      element: <LeadsMainLayout />,
      children: [
        // My Leads
        {
          path: "my-leads",
          element: <LeadsLayout />,
          children: [
            {
              path: "overview",
              element: <LeadsOverview />,
            },
            {
              path: "lead",
              element: <Lead />,
            },
          ],
        },
        // My Team
        {
          path: "team",
          element: <LeadsTeamLayout />,
          children: [
            {
              path: "overview",
              element: <TeamsOverview />,
            },
            {
              path: "lead",
              element: <TeamLeads />,
            },
          ],
        },
        // Organization
        {
          path: "organization",
          element: <LeadsOrganizationLayout />,
          children: [
            {
              path: "overview",
              element: <OrganizationOverview />,
            },
            {
              path: "lead",
              element: <OrganizationList />,
            },
            {
              path: "recycled-leads",
              element: <OrgRecycledLeadList />,
            },
          ],
        },
      ],
    },

    // Agents
    // {
    //   path: "/agents",
    //   element: <AgentsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "agent",
    //       element: <SettingAgents />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    {
      path: "/sales",
      element: <SaleMainLayout />,
      children: [
        // My Account
        {
          path: "sale",
          element: <SaleLayout />,
          children: [
            {
              path: "overview",
              element: <SaleOverview />,
            },
            {
              path: "sale-list",
              element: <Sale />,
            },
            {
              path: "assigned-sale-list",
              element: <SaleAssigment />,
            },
          ],
        },
        // My Team Account
        {
          path: "team",
          element: <SaleTeamLayout />,
          children: [
            {
              path: "overview",
              element: <SaleTeamOverview />,
            },
            {
              path: "sale-list",
              element: <SaleTeam />,
            },
            {
              path: "assigned-sale-list",
              element: <TeamSaleAssigment />,
            },
          ],
        },
        // Organization Accounts
        {
          path: "organization",
          element: <SaleOrgLayout />,
          children: [
            {
              path: "overview",
              element: <SaleOrganizationOverview />,
            },
            {
              path: "sale-list",
              element: <OrganizationSale />,
            },
            {
              path: "assigned-sale-list",
              element: <OrganizationSaleAssigment />,
            },
          ],
        },
      ],
    },

    // {
    //   path: "/devices",
    //   element: <DevicesLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "device",
    //       element: <Device />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // Users
    // {
    //   path: "/clients",
    //   element: <UsersLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "client",
    //       element: <SettingsUsers />,
    //     },
    //     // add other nested configs...
    //   ],
    // },
    // brands
    // {
    //   path: "/brands",
    //   element: <BrandsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "brand",
    //       element: <SettingsBrands />,
    //     },
    //     // add other nested configs...
    //   ],
    // },
    // packages
    // {
    //   path: "/packages",
    //   element: <PackagesLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "package",
    //       element: <SettingsPackages />,
    //     },
    //     // add other nested configs...
    //   ],
    // },
    // merchants
    // {
    //   path: "/merchants",
    //   element: <MerchantsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "merchant",
    //       element: <SettingsMerchants />,
    //     },
    //     {
    //       path: "type",
    //       element: <SettingMerchantsType />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // Prodcuts
    // {
    //   path: "/products",
    //   element: <ProductsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "product",
    //       element: <SettingsProducts />,
    //     },
    //     // add other nested configs...
    //   ],
    // },
    // Lost Deals
    // {
    //   path: "/lost-deals",
    //   element: <LostDealLayout />,
    //   children: [
    //     {
    //       path: "lost-deal",
    //       element: <SettingsLostDeals />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // teams
    // {
    //   path: "/teams",
    //   element: <TeamsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "team",
    //       element: <SettingsTeams />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // dashboard
    {
      path: "/dashboard",
      element: <DashboardLayoput />,
      children: [
        {
          path: "overview",
          element: <Dashboard />,
        },
        {
          path: "my-team",
          element: <TeamDashbaord />,
        },
        {
          path: "organization",
          element: <OrganizationDashboard />,
        },
      ],
    },


    //  wallets
    {
      path: "/wallets",
      element: <WalletsLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "wallet/:id",
          element: <Wallet />,
        },
        // add other nested configs...
      ],
    },

    // lead Details

    {
      path: "/leads",
      element: <LeadDetailLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "leadDetail/:id",
          element: <LeadDetailMain />,
        },
        // add other nested configs...
      ],
    },

    // {
    //   path: "/accounts",
    //   element: <AccountsLayout />,
    //   children: [

    //     {
    //       path: "account",
    //       element: <Accounts />,
    //     },

    //   ],
    // },

    // Accounts

    {
      path: "/accounts",
      element: <AccountsMainLayout />,
      children: [
        // My Account
        {
          path: "account",
          element: <AccountsLayout />,
          children: [
            {
              path: "overview",
              element: <AccountsOverview />,
            },
            {
              path: "account-list",
              element: <Accounts />,
            },
          ],
        },
        // My Team Account
        {
          path: "team",
          element: <AccountsTeamLayout />,
          children: [
            {
              path: "overview",
              element: <AccountsTeamsOverview />,
            },
            {
              path: "account-list",
              element: <TeamAccounts />,
            },
          ],
        },
        // Organization Accounts
        {
          path: "organization",
          element: <AccountsOrganizationLayout />,
          children: [
            {
              path: "overview",
              element: <AccountsOrganizationOverview />,
            },
            {
              path: "account-list",
              element: <OrganizationAccounts />,
            },
          ],
        },
      ],
    },

    {
      path: "/accounts",
      element: <AccountDetailLayout />,
      children: [
        {
          path: "account-details/:id",
          element: <AccountDetailMain />,
        },
        // add other nested configs...
      ],
    },

    {
      path: "/contacts",
      element: <ContactDetailLayout />,
      children: [
        {
          path: "contact-details/:id",
          element: <ContactDetailMain />,
        },
        // add other nested configs...
      ],
    },

    // {
    //   path: "/deals",
    //   element: <DealsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "deal",
    //       element: <Deals />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // Main deals
    {
      path: "/deals",
      element: <DealsMainLayout />,
      children: [
        // My Leads
        {
          path: "deal",
          element: <DealsLayout />,
          children: [
            {
              path: "overview",
              element: <DealsOverview />,
            },
            {
              path: "deal-list",
              element: <Deals />,
            },
          ],
        },
        // My Team
        {
          path: "team",
          element: <DealsTeamLayout />,
          children: [
            {
              path: "overview",
              element: <DealsTeamOverview />,
            },
            {
              path: "deal-list",
              element: <TeamDeals />,
            },
          ],
        },
        // Organization
        {
          path: "organization",
          element: <DealsOrganizationLayout />,
          children: [
            {
              path: "overview",
              element: <DealsOrganizationOverview />,
            },
            {
              path: "deal-list",
              element: <DealsOrganization />,
            },
          ],
        },
      ],
    },

    {
      path: "/deals",
      element: <DealDetailLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "dealDetail/:id",
          element: <DealDetailMain />,
        },
        // add other nested configs...
      ],
    },

    {
      path: "/projects",
      element: <ProjectDetailLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "projectDetail/:key",
          element: <ProjectDetailMain />,
        },
        // add other nested configs...
      ],
    },

    // {
    //   path: "/activites",
    //   element: <ActivityLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     // {
    //     //   path: "contact",
    //     //   element: <Contacts />,
    //     // },

    //     {
    //       path: "activity",
    //       element: <Activity />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    // Activities

    {
      path: "/activites",
      element: <ActivityMainLayout />,
      children: [
        // My Account
        {
          path: "activity",
          element: <ActivityLayout />,
          children: [
            {
              path: "overview",
              element: <ActivityOverview />,
            },
            {
              path: "activity-list",
              element: <Activity />,
            },
          ],
        },
        // My Team Account
        {
          path: "team",
          element: <ActivityTeamLayout />,
          children: [
            {
              path: "overview",
              element: <ActivityTeamOverview />,
            },
            {
              path: "activity-list",
              element: <ActivityTeam />,
            },
          ],
        },
        // Organization Accounts
        {
          path: "organization",
          element: <ActivityOrgLayout />,
          children: [
            {
              path: "overview",
              element: <ActivityOrganizationOverview />,
            },
            {
              path: "activity-list",
              element: <OrganizationActivity />,
            },
          ],
        },
      ],
    },

    {
      path: "/logs",
      element: <LogsLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        // {
        //   path: "contact",
        //   element: <Contacts />,
        // },

        {
          path: "log",
          element: <Logs />,
        },
        // add other nested configs...
      ],
    },

    {
      path: "/refunds",
      element: <RefundMainLayout />,
      children: [
        // Organization
        {
          path: "organization",
          element: <RefundOrgLayout />,
          children: [
            {
              path: "overview",
              element: <OrgRefundOverview />,
            },
            {
              path: "refund",
              element: <OrgRefunds />,
            },
            {
              path: "report-by-department",
              element: <OrgRefundsByDepartment />,
            },
            {
              path: "report-by-sales-agent",
              element: <OrgRefundsBySalesAgent />,
            },
            {
              path: "report-by-account-manager",
              element: <OrgRefundsByAccountManager />,
            },
            {
              path: "report-by-brand",
              element: <OrgRefundsByBrand />,
            },
            {
              path: "report-by-merchant",
              element: <OrgRefundsByMerchant />,
            },
            {
              path: "report-by-product",
              element: <OrgRefundsByProduct />,
            },
            {
              path: "report-by-source",
              element: <OrgRefundsBySource />,
            },
            {
              path: "report-by-team-lead",
              element: <OrgRefundsByTeamLead />,
            },
          ],
        },


      ],
    },

    {
      path: "/projects",
      element: <ProjectsLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "project",
          element: <Project />,
        },
        // add other nested configs...
      ],
    },

    // {
    //   path: "/brands",
    //   element: <BrandsLayout />,
    //   children: [
    //     // { path: "", element: <OrganizationReportMain /> },
    //     {
    //       path: "brand",
    //       element: <Brand />,
    //     },
    //     // add other nested configs...
    //   ],
    // },

    {
      path: "/organization",
      element: <OrganizationLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "employeedirectory",
          element: <OrganizationEmployeeDirectory />,
        },
        // add other nested configs...
      ],
    },

    {
      path: "/tasks",
      element: <TaskLayout />,
      children: [
        // { path: "", element: <OrganizationReportMain /> },
        {
          path: "overview",
          element: <TasksOverview />,
        },
        {
          path: "my-task",
          element: <TaskList />,
        },
        // add other nested configs...
      ],
    },

    /// New operations

    {
      path: "/operations",
      element: <OperationsMainLayout />,
      children: [
        {
          path: "agents",
          element: <AgentsLayout />,
          children: [
            {
              path: "overview",
              element: <AgentsOverview />,
            },
            {
              path: "agent-list",
              element: <SettingAgents />,
            },
          ],
        },

        {
          path: "brand",
          element: <BrandsLayout />,
          children: [
            {
              path: "overview",
              element: <BrandsOverview />,
            },
            {
              path: "brand-list",
              element: <SettingsBrands />,
            },
          ],
        },

        {
          path: "lost-deals",
          element: <LostDealLayout />,
          children: [
            {
              path: "lost-deal",
              element: <SettingsLostDeals />,
            },
          ],
        },

        {
          path: "merchant",
          element: <MerchantsLayout />,
          children: [
            {
              path: "overview",
              element: <MerchantsOverview />,
            },
            {
              path: "merchant-list",
              element: <SettingsMerchants />,
            },
            {
              path: "merchant-type",
              element: <SettingMerchantsType />,
            },
          ],
        },

        {
          path: "package",
          element: <PackagesLayout />,
          children: [
            {
              path: "overview",
              element: <PackagesOverview />,
            },
            {
              path: "package-list",
              element: <SettingsPackages />,
            },
          ],
        },

        {
          path: "product",
          element: <ProductsLayout />,
          children: [
            // {
            //   path: "overview",
            //   element: <ProductsOverview />,
            // },
            {
              path: "product-list",
              element: <SettingsProducts />,
            },
            {
              path: "category-list",
              element: <SettingsProductsCategory />,
            },
            {
              path: "package-list",
              element: <SettingsProductsPackages />,
            },
          ],
        },

        {
          path: "team",
          element: <TeamsLayout />,
          children: [
            {
              path: "overview",
              element: <SettingsTeamsOverview />,
            },
            {
              path: "team-list",
              element: <SettingsTeams />,
            },
          ],
        },

        {
          path: "client",
          element: <UsersLayout />,
          children: [
            {
              path: "overview",
              element: <ClientsOverview />,
            },
            {
              path: "client-list",
              element: <SettingsUsers />,
            },
          ],
        },
      ],
    },


    // System Settings

    {
      path: "/system-settings",
      element: <SystemSettingsLayout />,
      children: [
        {
          path: "",
          element: <SystemSettings />,
        },
        // add other nested configs...
      ],
    },

    // Lead Status
    {
      path: "/lead-status",
      element: <LeadStatusLayout />,
      children: [
        {
          path: "",
          element: <LeadStatusList />,
        },
        // add other nested configs...
      ],
    },

    // CLient Renewals
    {
      path: "/renewals-tracker",
      element: <ClientRenewalsLayout />,
      children: [
        {
          path: "",
          element: <ClientRenewalsTracker />,
        },
        // add other nested configs...
      ],
    },


    // Client Health
    {
      path: "/client-health",
      element: <ClientHealthLayout />,
      children: [
        {
          path: "health-score-factor",
          element: <HealthFactorList />,
        },
        {
          path: "health-score-thresholds",
          element: <HealthScoreThresholds />,
        },
        {
          path: "priority-flags",
          element: <HealthPriorityFlags />,
        },
        // add other nested configs...
      ],
    },

    {
      path: "*",
      element: <Navigate to="/dashboard/overview" replace />,
    },
  ];

  const publicRoutes = [
    { path: "/login", element: <Login /> },
    { path: "*", element: <Navigate to="/login" replace /> },
  ];

  const renderRoutes = (routes) =>
    routes.map(({ path, element, index, children }, i) => (
      <Route key={i} path={path} element={element} index={index}>
        {children && renderRoutes(children)}
      </Route>
    ));

  return (
    <Routes>
      {state?.isLogin === true
        ? renderRoutes(privateRoutes)
        : state?.isLogin === false
          ? renderRoutes(publicRoutes)
          : null}
    </Routes>
  );
};

export default MyRoutes;
